












import { Component, Vue, Prop } from 'vue-property-decorator';

import { IErrors } from './types';

@Component
export default class Errors extends Vue implements IErrors {
  @Prop({ type: Array, default: () => [] })
  errors: Array<any>;

  get firstErrorInErrors() {
    const errors = Object.values(this.errors);
    return errors.length === 1 && errors[0];
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/errors/Errors.vue